import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

import Jobs from '../../smallApps/jobs';
import Auth from '../../smallApps/auth';
import Users from '../../smallApps/users';
import NotFound from '../../smallApps/not-found';
import CandidatesShare from '../../smallApps/share-candidates';
import Calendar from '../../smallApps/calendar';
import SelfServe from '../../smallApps/selfserve';
import SelfServePaymentComplete from '../../smallApps/selfserve/pages/payment-complete';
import SelfServePaymentCancelled from '../../smallApps/selfserve/pages/payment-cancelled';
import Dashboard from '../../smallApps/dashboard';
import Settings from '../../smallApps/settings';
import OutreachUnsubscribe from '../../smallApps/outreach/pages/unsubscribe';

const wrapPrivateRoute = (element: JSX.Element) => {
  return <PrivateRoute>{element}</PrivateRoute>;
};

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* The dashboard is the landing surface. Changed from /jobs so a
            signed-in user arrives at the overview rather than a list. */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/shared-candidates/*"
          element={wrapPrivateRoute(<CandidatesShare />)}
        />
        <Route path="/dashboard/*" element={wrapPrivateRoute(<Dashboard />)} />
        <Route path="/jobs/*" element={wrapPrivateRoute(<Jobs />)} />
        <Route path="/users/*" element={wrapPrivateRoute(<Users />)} />
        <Route path="/calendar/*" element={wrapPrivateRoute(<Calendar />)} />
        <Route path="/settings/*" element={wrapPrivateRoute(<Settings />)} />
        <Route path="/auth/*" element={<Auth />} />
        {/* Public: prospects have no account until step 2 of this flow. */}
        <Route path="/selfserve/*" element={<SelfServe />} />
        {/*
          Where Stripe Checkout sends the browser back - success_url and
          cancel_url, both built in SelfServeSignupService.submit. Public and
          NOT nested under /selfserve/*: reached with no SelfServeProvider in
          scope, possibly on a different device than qualify/account ran on.
          (There used to be a third route here, /signup/confirm, for an
          emailed confirmation link between account details and payment -
          removed 2026-09-16 along with that step; submit() now opens Stripe
          Checkout directly.)
        */}
        <Route
          path="/signup/payment-complete"
          element={<SelfServePaymentComplete />}
        />
        <Route
          path="/signup/payment-cancelled"
          element={<SelfServePaymentCancelled />}
        />
        {/*
          Where EmailOutreachChannel points the unsubscribe link it embeds in
          every outreach-sequence send (avrio-backend's
          app.customer-base-url + /outreach/unsubscribe?token=...). Public
          and top-level for the same reason payment-complete is: reached by
          an outreach recipient with no Avrio session and possibly no Avrio
          account at all - the token in the query string is the only
          authorization, verified server-side on the confirming POST, not
          here.
        */}
        <Route
          path="/outreach/unsubscribe"
          element={<OutreachUnsubscribe />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
